import { LoadingSpinner } from '@app/shared/ui/atoms/Common';
import { UserListItem, UserListItemProps } from '@app/shared/ui/molecules/Friends';
import { NotFound } from '@app/shared/ui/molecules/Common';
import { cn } from '@app/shared/utils/common';

interface UserListProps {
  users: UserListItemProps[];
  isUsersLoading: boolean;
  className?: string;
}

export function UserList({ users, isUsersLoading, className = '' }: UserListProps) {
  const renderContent = () => {
    if (isUsersLoading) {
      return <LoadingSpinner size="lg" />;
    } else if (users.length === 0) {
      return <NotFound />;
    }

    return users.map((user) => <UserListItem key={user.index} {...user} />);
  };

  return <div className={cn('rounded-t-xl bg-blue-soft py-2.5', className)}>{renderContent()}</div>;
}
